import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearGame, leaveGame } from '@/store/gameSlice';
import { stopMusic } from '@/audio/rushAudio';
import type { AppDispatch } from '@/store';
import type { GameState } from '@/types';
import './QuitGameButton.css';

export function QuitGameButton({ gameId, game }: { gameId: string; game: GameState | null }) {
  const dispatch = useDispatch<AppDispatch>();
  const [open, setOpen] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const humans = (game?.players || []).filter((player) => !player.isAI).length;
  const solo = humans <= 1;

  const confirm = async () => {
    if (!gameId || leaving) return;
    setLeaving(true);
    stopMusic();
    const result = await dispatch(leaveGame(gameId));
    if (leaveGame.fulfilled.match(result)) {
      dispatch(clearGame());
      window.location.href = '/lobby';
      return;
    }
    setLeaving(false);
    setOpen(false);
  };

  return (
    <>
      <button type="button" className="quit-game-fixed" onClick={() => setOpen(true)} disabled={leaving}>
        {leaving ? 'Leaving...' : 'Quit Game'}
      </button>
      {open && (
        <div className="quit-confirm-overlay" onClick={() => !leaving && setOpen(false)}>
          <div className="quit-confirm-dialog" onClick={(event) => event.stopPropagation()}>
            <h2>Quit Game?</h2>
            <p>
              {solo
                ? 'This ends the game. You will return to the lobby.'
                : 'You will return to the lobby. Everyone else keeps playing, and your land goes back to the store for them to buy.'}
            </p>
            <div className="quit-confirm-buttons">
              <button type="button" className="quit-confirm-cancel" onClick={() => setOpen(false)} disabled={leaving}>
                Cancel
              </button>
              <button type="button" className="quit-confirm-quit" onClick={confirm} disabled={leaving}>
                {leaving ? 'Leaving...' : 'Quit Game'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
